<template>
  <div v-show="!hide">
    <v-combobox
      v-model="selected"
      :loading="fetchingUserList"
      :label="label"
      :items="sharedUsers"
      :filter="filter"
      dense
      clearable
      persistent-hint
    >
      <template v-slot:selection="data">
        <v-chip
          :key="JSON.stringify(data.item)"
          :selected="data.selected"
          :disabled="data.disabled"
          class="v-chip--select-multi"
          @click.stop="data.parent.selectedIndex = data.index"
          @input="data.parent.selectItem(data.item)"
        >
          <v-avatar v-if="data.item.text" color="white" class="primary--text">
            <img
              v-if="data.item.text"
              src="/icons/android-chrome-512x512.png"
              alt=""
            />
          </v-avatar>
          {{ data.item.text || data.item }}
        </v-chip>
      </template>
    </v-combobox>
  </div>
</template>

<script>
import { SharedUsers } from '../../../models/SharedUsers'
import { InternshipsSpecialty } from '../../../models/Content'
import _ from 'lodash'
import { mapGetters } from 'vuex'
export default {
  props: {
    label: { type: String, default: '' },
    value: { type: String, default: '' },
    autonomyId: { type: String, default: '' },
    selectedAutonomy: { type: String, default: '' }
  },
  data() {
    return {
      fetchingUserList: true,
      hide: this.autonomyId === this.selectedAutonomy
    }
  },
  computed: {
    ...mapGetters(['user']),
    selected: {
      get() {
        const user = this.sharedUsers.find(r => r.value === this.value)
        return user ? user : this.value
      },
      set(user) {
        let value = null
        if (typeof user === 'string') {
          value = user
        } else if (user && user.value) {
          value = user.value
        }
        this.$emit('input', value)
      }
    },

    sharedUsers() {
      const users = _.orderBy(SharedUsers.query().get(), [
        'firstName',
        'lastName'
      ]).filter(user => user.firstName !== undefined && !!user.license)
      return users.map(i => ({
        text: i.firstName + ' ' + i.lastName + ' (' + i.license + ' )',
        value: i.id,
        specialty: i.specialty
      }))
    }
  },
  methods: {
    filter(item, queryText, itemText) {
      const normalizedDescription = itemText
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      const normalizedQueryText = queryText
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      return (
        item.value.toLowerCase().includes(normalizedQueryText) ||
        normalizedDescription.includes(normalizedQueryText)
      )
    }
  },

  created() {
    // get all relevant specialties
    // let validSpecialties = []
    // validSpecialties = InternshipsSpecialty.query()
    //   .where(l => l.specialities.includes(this.$store.getters.specialty))
    //   .get()
    //   .map(r => r.internshipSpeciality)
    // validSpecialties.push(this.$store.getters.specialty)

    // get all Xerpa users
    SharedUsers.fetch(this.$store.getters.accessToken, [
      this.$store.getters.specialty
    ])
      .then(() => {
        return (this.fetchingUserList = false)
      })
      .catch(err => {
        return this.$store.dispatch(
          'showErrorSnackbar',
          err.message || 'Something went wrong'
        )
      })
  },

  watch: {
    selectedAutonomy(newAutonomy) {
      if (newAutonomy === this.autonomyId) {
        const user = this.sharedUsers.find(r => r.value === this.user.id)
        this.selected = user ? user : this.value
        this.hide = true
      } else if (this.selected?.value === this.user.id) {
        this.selected = ''
        this.hide = false
      } else {
        this.hide = false
      }
    }
  }
}
</script>
